<!-- components/CustomerServiceFloat.vue -->
<template>
  <div class="customer-service-float" :class="{ 'is-open': isOpen }">
    <!-- 新增购物车按钮 -->
    <div class="cart-btn" @click="goToCart">
      <i class="el-icon-shopping-cart-1"></i>
      <div class="text">购物车</div>
      <div class="cart-badge" v-if="cartItemCount > 0">{{ cartItemCount }}</div>
    </div>

    <div class="float-btn" @click="toggleService">
      <i class="el-icon-service"></i>
      <div class="text">在线客服</div>
    </div>

    <div v-if="isOpen" class="service-panel">
      <div class="panel-header">
        <h3>在线客服</h3>
        <button @click="closeService">×</button>
      </div>
      <div class="panel-content">
        <!-- 客服聊天内容 -->
      </div>
    </div>
  </div>
</template>

<script>
import { getUserService } from "@/api/index";

export default {
  name: "CustomerServiceComponent",
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    async toggleService() {
      const result = await getUserService();
      if (result.code === 1) {
        let wechatUrl = result.data.wechatUrl;
        window.open(wechatUrl);
      }
      // this.isOpen = !this.isOpen
    },
    closeService() {
      this.isOpen = false;
    },
    // 新增跳转购物车方法
    goToCart() {
      if (!this.$store.state.user.isLogin) {
        this.$message.error("请先登录");
        return;
      } else {
        if (this.$route.name !== "cart") {
          this.$router.push("/cart"); // 根据实际购物车路由调整路径
        }
      }
    },
  },
  computed: {
    // 使用计算属性获取 Vuex 中的购物车数量
    cartItemCount() {
      return this.$store.state.system.cartNum ?? 0;
    },
  },
  watch: {
    // 正确的监听器位置，与 methods 同级
    "$store.state.system.cartNum": function (newValue) {
      // 当 Vuex 中的 cartNum 变化时，组件会自动更新
      console.log("购物车数量更新:", newValue);
    },
  },
};
</script>

<style scoped>
.customer-service-float {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 1000;
}

.cart-btn {
  padding: 20px 14px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
  color: #767676;
  margin-bottom: 15px; /* 与客服按钮保持间距 */
  position: relative; /* 为角标定位做准备 */

  .el-icon-shopping-cart-1 {
    font-size: 20px;
    position: relative;
  }

  .text {
    font-size: 13px;
    padding-top: 8px;
  }
}

/* 购物车角标样式 - 修改定位 */
.cart-badge {
  position: absolute;
  top: 5px;
  right: 10px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  background-color: #ff4d4f;
  color: white;
  font-size: 12px;
  text-align: center;
  border-radius: 9px;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.float-btn {
  padding: 20px 14px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
  color: #767676;

  .el-icon-service {
    font-size: 20px;
  }

  .text {
    font-size: 13px;
    padding-top: 8px;
  }
}

.service-panel {
  position: absolute;
  right: 0;
  bottom: 70px;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
</style>
